import axios from "axios";
import Config from "src/config";

const v1_actionWboTemplatesCategoryLogs = (clienteId, params = {}) => {
    const query = new URLSearchParams();
    if (params.templateId) query.set('templateId', params.templateId);
    if (params.canalId) query.set('canalId', params.canalId);
    if (params.page) query.set('page', params.page);
    if (params.limit) query.set('limit', params.limit);

    const queryString = query.toString() ? `?${query.toString()}` : '';
    const url = `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/canais/wbo/templates/logs/categoria${queryString}`;

    return axios({
        method: "get",
        url: url
    });
};

export default v1_actionWboTemplatesCategoryLogs;
